<script setup lang="ts">
import { ref, computed } from 'vue';
import { useViewComposable } from '@/views/composable';
import AutoComplete from 'primevue/autocomplete';
import Button from 'primevue/button';

const props = defineProps<{
  ruleContent: any;
}>();

const emits = defineEmits<{ 'update:ruleContent': [dataFilter: any] }>();

const ruleSelected = ref<any>('');
const filterRuleOption = ref<any>([]);
const { ruleHistoryList } = useViewComposable();

const ruleContentSelectedData = computed({
  get() {
    return props.ruleContent;
  },
  set(value) {
    emits('update:ruleContent', value);
  }
});

const getListRuleHistory = () => {
  ruleContentSelectedData.value = ruleSelected.value;
};

const searchRuleHistory = (event: any) => {
  if (!event?.query?.trim().length) {
    filterRuleOption.value = [...ruleHistoryList];
  } else {
    filterRuleOption.value = ruleHistoryList.filter((item: any) => {
      return item.label?.toLowerCase().startsWith(event.query.toLowerCase());
    });
  }
};

const clearSelected = () => {
  ruleSelected.value = '';
  ruleContentSelectedData.value = {};
};

const clearByInput = () => {
  ruleContentSelectedData.value = {};
};
</script>
<template>
  <div>
    <div class="flex align-items-center gap-4 mb-6 search-rule">
      <span class="font-bold text-2xl w-5"> {{ $t('common.labels.rule_history') }}</span>
      <AutoComplete id="select-rule-history" v-model="ruleSelected" @clear="clearByInput()" :suggestions="filterRuleOption" @complete="searchRuleHistory($event)" optionLabel="label" completeOnFocus class="w-full" forceSelection />
      <div>
        <i class="pi pi-times-circle ml-2 text-red-500 cursor-pointer" @click="clearSelected()"></i>
      </div>
      <div>
        <Button id="btn-submit" :disabled="!ruleSelected" @click="getListRuleHistory()" :label="$t('common.buttons.submit')"></Button>
      </div>
    </div>
  </div>
</template>
